/* eslint-disable max-lines-per-function */
import React, { useRef, useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';
import TvService from '../../../../services/tvs/TvService.js';
import { Dropdown } from 'primereact/dropdown.js';
import { mostrarMensagemSucesso, mostrarMensagemErro } from '../../shared/getMensagens';

export function VincularGrupo({
    rowSelecionada,
    modalVincularTVAberto,
    setModalVincularTVAberto,
    setRecarregarDataTable,
    dadosGrupo
}) {
    const zero = 0;
    const mensagemToast = useRef(null);
    const [dadosParametros, setDadosParametros] = useState([]);
    const [place, setPlace] = useState('0');
           
    const [idGrupo, setIdGrupo] = useState(0);
    const [arrayIncial, setArrayIncial] = useState(true);
    
    const onCli = event => {
        setIdGrupo(event.target.value.id);                  
        setArrayIncial(event.target.value);
    };
     
    const handleChange = async () => {
        let id = 0;

        if(rowSelecionada.idGrupo) {
            id = rowSelecionada.idGrupo;}

        try {
            await TvService.desvincularTvGrupo(id, [rowSelecionada.id]);
            await TvService.vincularTvGrupo(idGrupo, [rowSelecionada.id]);
            fecharModal();            
            setRecarregarDataTable(true);             
            mostrarMensagemSucesso(mensagemToast, 'Alterado com sucesso!');
        } catch (error) {
            mostrarMensagemErro(mensagemToast, 'Não foi possível alterar os dados! Tente novamente mais tarde.');
            throw new Error(error);
        }
    };

    const desvincular = async () => {
        try {
            await TvService.desvincularTvGrupo(rowSelecionada.idGrupo, [rowSelecionada.id]);
            
            fecharModal();
            setRecarregarDataTable(true);
                         
            mostrarMensagemSucesso(mensagemToast, 'Grupo desvinculado com sucesso');
        } catch (error) {
            mostrarMensagemErro(mensagemToast, 'Não foi possivel desvincular o grupo');
            throw new Error(error);
        }
    };

    const limpaVinculacao = () => {
        setPlace('Aparelho nao vinculado');
        setArrayIncial({});
    } ;
    
    useEffect(() => {
        (async () => {    
            const dadosGrupoFilter = dadosGrupo.filter(e => e.id === rowSelecionada.idGrupo);
 
            dadosGrupoFilter.length > zero ? setArrayIncial(dadosGrupoFilter[zero]): limpaVinculacao();                
            setDadosParametros(dadosGrupo);
        })();
    }, [rowSelecionada]);
   
    const fecharModal = () => setModalVincularTVAberto(false);    
   
    return (
        <>
            <Growl ref={mensagemToast} />
            <Dialog
                                    
                header={'Vincular Grupo de programação'}
                visible={modalVincularTVAberto}
                dismissableMask
                onHide={fecharModal}
                
            >
                <div className="p-grid p-fluid">
                    <div style={{ height: '18em' }} className="p-col-12">  
                        <Dropdown 
                            value={arrayIncial} 
                            options={dadosParametros} 
                            onChange={onCli} 
                            placeholder={place} 
                            optionLabel="nome" 
                            style={{ width: '8em' }}
                        />
                    </div>
                    
                    <div className="p-col-6">
                       
                        <Button                                        
                            label="Vincular"
                            disabled={!arrayIncial.nome}                           
                            iconPos="right"
                            onClick={handleChange}                       
                        />                        
                    </div>
                    <div className="p-col-6">
                        <Button
                            disabled={!rowSelecionada.idGrupo}                                                                    
                            label="Desvincular"                            
                            iconPos="right"
                            onClick={desvincular}                        
                        />                                               
                    </div>
                </div>
                
            </Dialog>
        </>
    );
}
